
import React, { useState, useEffect } from 'react';
import { ReactSession } from 'react-client-session';
import { BrowserRouter as Router, Routes, Route, Link, useNavigate, Navigate, useLocation } from 'react-router-dom';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Drawer from '@mui/material/Drawer';
import { useMediaQuery } from 'react-responsive';
import Avatar from '@mui/material/Avatar';

import { deepOrange, deepPurple } from '@mui/material/colors';

import CloseIcon from '@mui/icons-material/Close';
import SettingsIcon from '@mui/icons-material/Settings';
import WbSunnyIcon from '@mui/icons-material/WbSunny';
import NightlightIcon from '@mui/icons-material/Nightlight';


import { LocalizationContext } from '../App';


const LoupeAppDrawerComponent = (props) => {

    const enableSettings = true;

    const themeSelectionCallback = props.themeCallback;
    const handleCancelCallback = props.cancelCallback;
    const handleCancelActivityCallback = props.cancelActivityCallback;
    const GdprCallback = props.GdprCallback;
    const setShowDrawerCallback = props.setShowDrawerCallback;
    const showDrawer = props.showDrawer;

    const navigate = useNavigate();
    const location = useLocation();    

    const isMobileView = useMediaQuery({
        query: '(max-width: 900px)'
    })

    const isDesktopView = useMediaQuery({
        query: '(min-width: 900px)'
    })

    const isLargeDesktopView = useMediaQuery({
        query: '(min-width: 1440px)'
    })

   
        

    return (
        <LocalizationContext.Consumer>

        { ({strings}) => (

            <React.Fragment key='drawer'>

            <Drawer
                anchor={ isMobileView == true ? 'left' : 'left' }
                onClose={() => setShowDrawerCallback(false)}
                open={showDrawer}>
                
                <Paper className="drawer padding" elevation={0} square> 

                    <Stack className="mb-6" direction="row" justifyContent="space-between">

                        <Button onClick={() => setShowDrawerCallback(false)}>
                            <CloseIcon />
                        </Button> 
            
                        <div>

                            <Stack direction='row'>
                                <Routes>
                                    {
                                        ["/", "/settings", "/about", "/activities-here", "/about-app"].map((path,index) => {
                                            return (
                                                <Route path={path} element={
                                                    <>
                                                        { enableSettings == true ? (
                                                            <Avatar variant="rounded" sx={{ color : '#FFF' }} onClick={() => { setShowDrawerCallback(false); navigate("/settings")}} className="padleft point">
                                                                <SettingsIcon />
                                                            </Avatar>
                                                        ) : ( <div /> )}
                                                    </>
                                                } key={index} />
                                            );
                                        }
                                    )}
                                </Routes>

                                <Avatar variant="rounded" sx={{ color : '#FFF', bgcolor : '#d81b60'}} className="padleft point" onClick={() => themeSelectionCallback( ReactSession.get("usertheme") == "light" ? 'dark' : 'light' )}>
                                    {ReactSession.get("usertheme") == "dark" ? <WbSunnyIcon /> : <NightlightIcon/> }
                                </Avatar>

                            </Stack>
                        </div>

                        

                    </Stack>

                    <Stack direction="column" justifyContent="flex-start" alignItems='flex-start'>

                        <Routes>
                            {
                                ["/", "/settings", "/about", "/start/:code", "/activities-here", "/about-app", "/activity-details/:language/:activityCode", "/activity-complete"].map((path,index) => {
                                    return (
                                        <Route path={path} element={
                                            <>
                                                <Button color="primary" variant="text" onClick={handleCancelCallback}>{strings.getString("controls.buttons.menu.start")}</Button>                              
                                                <Divider className="mb-3" />
                                            </>
                                        } key={index} />
                                    );
                                }
                            )}

                            <Route path={`/activity-content/:language/:code`} element={
                                <>
                                    <Button color="primary" variant="text" onClick={handleCancelActivityCallback}>{strings.getString("controls.buttons.menu.cancelactivity")}</Button>                              
                                    <Divider className="mb-5" />
                                </>
                            } />

                        </Routes>

                        <Button color="primary" fullWidth={false} onClick={() => GdprCallback() }>{strings.getString("texts.titles.privacy")}</Button>
                        <Button color="primary" fullWidth={false} onClick={() => { setShowDrawerCallback(false); navigate('/about-app')} }>{strings.getString("controls.buttons.imprint")}</Button>

                        <Divider className="mb-5" />

                    </Stack>
                </Paper>

            </Drawer>
            </React.Fragment>
        )}
        </LocalizationContext.Consumer>
    )

}
export default LoupeAppDrawerComponent;